export default {
  data() {
    return {
      isBathhouseGuestDropdownVisible: false, // 控制湯屋乘客選單的顯示
      bathhouseAdultCount: 0, // 湯屋成人數量
      bathhouseChildCount: 0, // 湯屋小孩數量
    };
  },
  computed: {
    totalBathhouseGuests() {
      return this.bathhouseAdultCount + this.bathhouseChildCount;
    },
  },
  methods: {
    toggleBathhouseGuestDropdown() {
      this.isBathhouseGuestDropdownVisible = !this.isBathhouseGuestDropdownVisible;
    },
    closeBathhouseGuestDropdown() {
      this.isBathhouseGuestDropdownVisible = false;
    },
    incrementBathhouseAdult() {
      this.bathhouseAdultCount++;
    },
    decrementBathhouseAdult() {
      if (this.bathhouseAdultCount > 0) this.bathhouseAdultCount--;
    },
    incrementBathhouseChild() {
      this.bathhouseChildCount++;
    },
    decrementBathhouseChild() {
      if (this.bathhouseChildCount > 0) this.bathhouseChildCount--;
    },
  },
};
